import { render, staticRenderFns } from "./NotesSvg.vue?vue&type=template&id=298292da"
import script from "./NotesSvg.vue?vue&type=script&lang=js"
export * from "./NotesSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports